import { RadioGroup } from "@Light/components/system/RadioGroup";
import type { Utility } from "@Light/services/lightTypes";
import { getUtilityBehavior } from "@Light/utils/utility";

export type UtilityRadioGroupProps = {
  name: string;
  utilities: Utility[];
  value?: Utility;
  onChange: (utility: Utility) => void;
  onClickProvideAddress?: () => void;
};

export const UtilityRadioGroup = ({
  name,
  utilities,
  value,
  onChange,
  onClickProvideAddress,
}: UtilityRadioGroupProps) => {
  const allUtilitiesCanSearch = utilities.every(
    (utility) =>
      getUtilityBehavior(utility.id).serviceLocationEntry === "search",
  );
  return (
    <div className="flex flex-col gap-3">
      <RadioGroup
        name={name}
        options={utilities.map((utility) => ({
          value: utility,
          label: utility.full_name,
        }))}
        value={value}
        onChange={onChange}
      />
      {allUtilitiesCanSearch && onClickProvideAddress ? (
        <button
          type="button"
          onClick={onClickProvideAddress}
          data-testid="zip-utility-provide-address"
          className="cursor-pointer text-center text-sm text-tertiary underline underline-offset-4"
        >
          Provide your address instead
        </button>
      ) : null}
    </div>
  );
};
